<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout justify-space-between>
        <v-flex xs3 sm3 md3 d-flex>
          <div>
            <permission-tooltip
                :permission="hasPermission('sharing_create')"
                :tooltip="{right: true, bottom: false, attach: false}"
            >
              <sharing-manage-modal
                  ref="sharingModal"
                  @sharing_stored="fetchData"
                  @sharing_closed="modalClosed()"
                  :currentSharing="currentSharing"
              />
            </permission-tooltip>
          </div>
        </v-flex>
        <v-flex xs3 sm3 md3 d-flex>
          <div>
            <v-text-field v-model="filters.search"
                          append-icon="search"
                          :label="trans('app.search.search')"
                          single-line
                          hide-details
                          solo
            ></v-text-field>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        :total-items="total"
        :loading="isLoading"
        :rows-per-page-items="[10,25,50,100]"
        :no-data-text="trans('app.search.no_data')"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            {{ props.item.email }}
          </td>
          <td class="text-center">
            <v-tooltip top v-if="props.item.accepted">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="green">check</v-icon>
              </template>
              <span v-html="trans('app.sharing.sharing_accepted')"></span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="red">close</v-icon>
              </template>
              <span v-html="trans('app.sharing.sharing_not_accepted')"></span>
            </v-tooltip>
          </td>
          <td>
            {{ props.item.created_at|format_date(FORMAT_DATETIME) }}
          </td>
          <td class="justify-end layout px-0 pr-4">
            <icon-button
                icon="edit"
                color="success"
                cls="mr-0 ml-0"
                @click="editItem(props.item)"
                :tooltip="{top: true, bottom: false, attach: false}"
                :iconOptions="{small: true}"
                :permission="hasPermission('sharing_edit')"
            >
              {{ 'app.edit' | trans }}
            </icon-button>
            <icon-button
                icon="delete"
                color="red"
                cls="mr-0 ml-0"
                @click="deleteItem(props.item)"
                :tooltip="{top: true, bottom: false, attach: false}"
                :iconOptions="{small: true}"
                :permission="hasPermission('sharing_delete')"
            >
              {{ 'app.delete' | trans }}
            </icon-button>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {trans} from "../../../app";
import {stringify} from "qs";
import debounce from "lodash/debounce";
import {mapGetters, mapActions} from "vuex"
import {FORMAT_DATETIME} from "../../../utils/dateFormatter";

export default {
  data: function () {
    return {
      FORMAT_DATETIME: FORMAT_DATETIME,
      currentSharing: null,
      headers: [
        {
          text: trans('app.email'), align: 'left', value: 'email', sortable: true,
        },
        {
          text: trans('app.sharing.accepted'), align: 'center', value: 'accepted', sortable: true,
        },
        {
          text: trans('app.createdAt'), align: 'left', value: 'created_at', sortable: true,
        },
        {
          text: '', align: 'center', sortable: false,
        },
      ],
      items: [],
      pagination: {
        rowsPerPage: 50,
        sortBy: 'email',
        descending: false,
      },
      total: 0,
      isLoading: true,
      filters: {
        search: null,
      }
    }
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  watch: {
    filters: {
      handler() {
        this.debounceFetch();
      },
      deep: true,
    },
    pagination: {
      handler(newValue, oldValue) {
        if (oldValue.page !== undefined) {
          this.fetchData();
        }
      },
      deep: true,
    },
  },
  created() {
    this.debounceFetch = debounce(this.fetchData, 300);
  },
  methods: {
    ...mapActions(['fetchSharedByMeCount']),
    resetSearch() {
      this.filters = {
        search: null
      };
      this.pagination.sortBy = 'email';
      this.pagination.descending = false;
    },
    async fetchData() {
      this.isLoading = true;
      const {sortBy, descending, page, rowsPerPage} = this.pagination;

      const query = {
        page: page,
        perPage: rowsPerPage,
        orderBy: sortBy,
        dir: descending ? 'desc' : 'asc',
        ...this.filters,
      };

      const response = await axios.get(`/v2/sharings/shared_by_me?${stringify(query, {skipNulls: true})}`);
      const {data, meta} = response.data;
      this.items = data;
      this.total = meta.total;
      this.pages = meta.last_page;
      this.isLoading = false;
    },
    deleteItem(item) {
      this.$confirmDanger(
          trans('app.sharing.confirm_sharing_removal', {name: item.email}),
          trans('app.sharing.remove_sharing')
      ).then(async () => {
        await axios.delete(`/v2/sharings/${item.id}`);
        await this.fetchData();
        this.$toast(trans('app.actions.removed', {name: trans('app.sharing.sharing_accusative')}));
        await this.fetchSharedByMeCount();
      }).catch((error) => {
        this.sentryCaptureException(error);
      });
    },
    editItem(item) {
      this.currentSharing = item;
      this.$refs.sharingModal.open();
    },
    modalClosed() {
      this.currentSharing = null;
    },
  }
}
</script>
